const quantityMarkup = `
	<button class="aa-quantity__button aa-quantity__button--dec button-reset" aria-label="Decrement quantity"><span class="aa-quantity__button-text">–</span></button>
	<div class="aa-quantity__value"></div>
	<button class="aa-quantity__button aa-quantity__button--inc button-reset" aria-label="Increment quantity"><span class="aa-quantity__button-text">+</span></button>
`;

class QuantityController {
	constructor(el) {
		this.el = el;
		this.autoUpdateCart = false;
		this.elements = {
			inc: null,
			dec: null,
			value: null,
			input: null,
			updateCartButton: null,
		};
		this.data = {
			min: null,
			max: null,
			value: null,
		};

		// Check if the data attribute is present.
		if (typeof this.el.dataset.autoUpdateCart !== 'undefined') {
			this.autoUpdateCart = true;
		}

		this.getAttribites();
		this.replaceMarkup();
		this.getElements();
		this.setEvents();

		this.updateState();
	}

	getAttribites() {
		this.elements.input = this.el.querySelector('.quantity input.qty');

		this.data.value = parseInt(this.elements.input.value, 10);
		this.data.min = parseInt(this.elements.input.min, 10);
		this.data.max = parseInt(this.elements.input.max, 10);

		if (Number.isNaN(this.data.max)) this.data.max = 999;
	}

	replaceMarkup() {
		// Hide the original mark-up.
		const quantity = this.el.querySelector('.quantity');

		quantity && quantity.classList.add('aa-quantity__original');

		// Add new markup using jQuery.
		jQuery(this.el).append(quantityMarkup);

		if (this.autoUpdateCart) {
			this.elements.updateCartButton =
				document.querySelector('.aa-update-cart');

			this.elements.updateCartButton.classList.add('aa-update-cart--hidden');
		}
	}

	getElements() {
		this.elements.value = this.el.querySelector('.aa-quantity__value');
		this.elements.inc = this.el.querySelector('.aa-quantity__button--inc');
		this.elements.dec = this.el.querySelector('.aa-quantity__button--dec');
	}

	setEvents() {
		this.elements.dec.addEventListener('click', (e) => {
			e.preventDefault();

			const newValue = this.data.value - 1;

			if (newValue <= this.data.min) {
				this.data.value = this.data.min;
			} else {
				this.data.value = newValue;
			}

			this.updateState();

			this.autoUpdateCart && this.triggerUpdateCart();
		});

		this.elements.inc.addEventListener('click', (e) => {
			e.preventDefault();

			const newValue = this.data.value + 1;

			if (newValue >= this.data.max) {
				this.data.value = this.data.max;
			} else {
				this.data.value = newValue;
			}

			this.updateState();

			this.autoUpdateCart && this.triggerUpdateCart();
		});
	}

	updateState() {
		this.elements.value.textContent = this.data.value;

		this.disableButton(this.elements.dec, this.data.value <= this.data.min);
		this.disableButton(this.elements.inc, this.data.value >= this.data.max);

		// Update the value and trigger a change using jQuery.
		const $input = jQuery(this.elements.input);

		$input.val(this.data.value);
		$input.trigger('change');
	}

	triggerUpdateCart() {
		jQuery(this.elements.updateCartButton).trigger('click');

		// Disable the buttons after clicking the 'update cart' button.
		this.disableButton(this.elements.dec, true);
		this.disableButton(this.elements.inc, true);
	}

	disableButton(button, disable = true) {
		button.classList.toggle('aa-quantity__button--disabled', disable);

		if (disable) {
			button.setAttribute('disabled', 'disabled');
		} else {
			button.removeAttribute('disabled');
		}
	}
}

const elements = [...document.querySelectorAll('.aa-quantity')];

elements.length && elements.forEach((el) => new QuantityController(el));
